import { useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Box } from '../../widgets'
import { SelectableList } from '../../forms'
import { Teams } from '../team'
import { industries } from '../../../lookups'

export const OrganisationIndustry = ({ active, organisationId }) => {
  const request = useRequest('tenant')
  const { push } = useStack()
  const { organisations } = useView('tenant')
  const { industry } = organisations.find(x => x.id === organisationId) || {}

  useShell({ active, mode: 'navigate narrow' })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(true, mobile) }))

  const handleOrganisationIndustry = ({ industry }) => {
    if(industry !== undefined) {
      return request('organisationUpdated', { id: organisationId, industry }).then(() => push(Teams, { props: { organisationId } }))
    }
  }

  return (
    <InputScreen
      onSubmit={handleOrganisationIndustry}
      formValues={{ industry }}
      footerButton="Next"
      title="Client&apos;s Industry type"
      description="What industry does your client&apos;s organisation work within? Choose the one that best fits their business"
      minHeight={0}
    >
      <Box overflow="auto" py={8}>
        <SelectableList name="industry" list={industries.map(({ name }) => name)}/>
      </Box>
    </InputScreen>
  )
}